var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhpIconClr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_360",
    "data-name": "Group 360",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40.331,
    height: 21.904,
    viewBox: "0 0 40.331 21.904",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_281",
    "data-name": "Rectangle 281",
    width: 40.331,
    height: 21.904,
    fill: "#8798d7"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_334",
    "data-name": "Group 334",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8203",
    "data-name": "Path 8203",
    d: "M20.186,0a33.528,33.528,0,0,1,12.22,2.233,15.5,15.5,0,0,1,5.9,3.893,7.067,7.067,0,0,1,2.021,5.088,6.939,6.939,0,0,1-1.6,4.107,14.212,14.212,0,0,1-5.491,4.036,28.824,28.824,0,0,1-8.67,2.288A37.324,37.324,0,0,1,17.4,21.8,28.066,28.066,0,0,1,5.313,18.429a11.922,11.922,0,0,1-4.1-3.653A6.729,6.729,0,0,1,2,6.153a15.967,15.967,0,0,1,6.127-4,29.366,29.366,0,0,1,8.5-1.935C17.812.122,19,.072,20.186,0M8.914,16l.464-2.585c.924,0,1.846.042,2.763-.009a3.605,3.605,0,0,0,3.632-2.956c.5-1.948-.386-3.371-2.372-3.611a29.932,29.932,0,0,0-3.269-.066c-.57-.006-1.142,0-1.719,0L6.712,16Zm18.107-2.586c.945,0,1.869.044,2.787-.009a3.593,3.593,0,0,0,3.6-2.938c.516-1.963-.375-3.438-2.391-3.624-1.635-.151-3.294-.031-4.971-.031l-1.694,9.183h2.2l.465-2.582m-8.884.068c.034-.109.074-.212.1-.318.31-1.461.615-2.923.931-4.382.025-.116.125-.31.19-.31.781,0,1.564.009,2.343.062a.6.6,0,0,1,.564.7,3.418,3.418,0,0,1-.056.582c-.254,1.214-.517,2.425-.784,3.674.688,0,1.345.007,2-.009a.339.339,0,0,0,.257-.191c.311-1.46.648-2.917.892-4.389a1.6,1.6,0,0,0-1.4-1.955A12.791,12.791,0,0,0,21.3,6.776c-.566-.028-1.134-.006-1.73-.006l.69-3.343H18.077l-2.1,10.054Z",
    transform: "translate(0 0)",
    fill: "#8798d7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8204",
    "data-name": "Path 8204",
    d: "M31.065,30.367a.976.976,0,0,1,0-.149c.2-1.052.4-2.1.615-3.236.837.037,1.674.021,2.494.129.672.089.927.508.9,1.191a1.919,1.919,0,0,1-2.041,2.06c-.654.023-1.309,0-1.971,0",
    transform: "translate(-21.369 -18.562)",
    fill: "#8798d7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8205",
    "data-name": "Path 8205",
    d: "M87.531,30.344l.639-3.4c.872.051,1.76.052,2.632.172.532.073.767.5.768,1.048a1.953,1.953,0,0,1-2.1,2.174c-.638.017-1.277,0-1.938,0",
    transform: "translate(-60.216 -18.538)",
    fill: "#8798d7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhpIconClr);
export default __webpack_public_path__ + "static/media/php-icon-clr.df857acb65cf619143f37da79c1432fc.svg";
export { ForwardRef as ReactComponent };